export class NoIdInWemiError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "NoIdInWemiError"
    }
}

export class NoItemInWemiError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "NoItemInWemiError"
    }
}